import {NgModule} from '@angular/core';
import {SharedModule} from '../shared/shared.module';
import {FileComponent} from './file.component';
import {FileService} from './file.service';
import {AuthenticationModule} from '@ngx-ivengi/authentication';

@NgModule({
  declarations: [
    FileComponent
  ],
  exports: [
    FileComponent
  ],
  imports: [
    SharedModule,
    AuthenticationModule
  ],
  providers: [
    FileService
  ]
})
export class FileModule {}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/file/file.module.ts